// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"921":"86f78f09","2535":"86f78f09","4427":"86f78f09","6998":"04c493a8"}[chunkId] + ".chunk.css";
};